import { IAgencyPermission } from 'shared/services/api/agents/agentsService';

import dateService, { dateFormats } from 'services/dateService';

export function prepareText(text: string, agencyName: string, time: string) {
  return text
    .replace('{agency}', `<b>${agencyName}</b>`)
    .replace('{date}', `<b>${dateService.format(time, dateFormats.date)}</b>`);
}

export function getAgencyOption(item: IAgencyPermission) {
  const id = item.agencyId !== undefined ? item.agencyId.toString() : item.id.toString();

  return { name: item.name ?? id, value: id };
}

export function getNudgeAgencyText(text: string, agency?: IAgencyPermission) {
  return text.replace('{agency}', `<b>${agency?.name ?? ''}</b>`);
}
